import React, { FC, useEffect, useState } from "react";
import {
  Button,
  Col,
  Flex,
  Form,
  Input,
  message,
  Row,
  Select,
  Space,
  Tabs,
} from "antd";
import { IUploadReferral } from "../../../interfaces/IReferral";
import { IDocumentFields } from "../../../interfaces/ICase";
import {
  PreAuthClaimField,
  PreAuthClaimResponse,
  PreAuthClaimSection,
  WizardStep,
} from "../../../interfaces/IPreAuthClaim";
import { renderCommonField } from "../CommonFields";
import {
  CheckOutlined,
  CloseCircleOutlined,
  DeleteOutlined,
  DownloadOutlined,
  EditOutlined,
  EyeOutlined,
  MinusCircleOutlined,
  SaveOutlined,
} from "@ant-design/icons";
import { Empty } from "antd";
import TabPane from "antd/es/tabs/TabPane";
import { useUserFunctionalities } from "../../../utils/UserFunctionalities";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../../store/store";
import ManualStatus from "../PreAuth/ManualStatusButton";
import { getVisitStageStates } from "../../../models/preAuthSlice";
import ClaimIDManuallyId from "../PreAuth/ClaimIDManuallyId";
import ManualPortalStatus from "../PreAuth/ManualPortalStatusButton";
import dayjs from "dayjs";
import { updateField } from "../../../models/preAuthClaimSlice";
import { errorMessage } from "../../../utils/notificationUtils";

type FieldType = {
  additionalAmountPaid: boolean;
  amount: string;
};

const initialValues: FieldType = {
  additionalAmountPaid: false,
  amount: "",
};

type PreAuthClaimProps = {
  activeStep: number;
  allWizardSteps: WizardStep[];
  onNext: () => void;
  onPrevious: () => void;
  onComplete: (step: number) => void;
  handleTabsChange?: any;
  handleFileChange?: any;
  error: string | null;
  handleDeleteList: CallableFunction;
  preAuthClaimData: PreAuthClaimResponse | null;
  caseClaimSubmissionId: number | null;
  editedFields: Record<string, Record<string, string>>;
  onFieldChange: (sectionKey: string, fieldId: string, value: string) => void;
  visitType: string | undefined;
  uploadedDocumentUrl: Array<IDocumentFields>;
  handleSaveChangesEchs: CallableFunction;
  isLoading: boolean;
  isEditable: boolean;
  handleEditable: CallableFunction;
  handleSetDocumentUrl: CallableFunction;
  handleOpen: any;
  handleDownloadDocument: CallableFunction;
  isDownloadingDocument?: boolean;
  downloadingDocumentUrl?: string;
  isSubmit: boolean;
  isSubmitted: boolean;
  handleDeficiencyModal?: any;
  closeDeficiencyModal?: any;
  deficiencyModal: boolean;
  deficiencyQuestions?: any;
  previewDocumentUrl: string;
  setDocumentName: any;
  handleDeficiencyModalAfterSave: any;
  portalSubmission: string | null;
  handleSaveToEdgePro: CallableFunction;
  procedureDropDown: any;
  handleDeleteProcedure: CallableFunction;
  handleApprove: any;
  isApproved: boolean;
  isApprovedInitiated: boolean;
  nextStage: any;
  setMoveToNext: CallableFunction;
};

const PreAuthClaimEchs: FC<PreAuthClaimProps & { form: any }> = ({
  form,
  ...props
}) => {
  const dispatch = useDispatch<AppDispatch>();
  // const [form] = Form.useForm();
  const [isAdditionalAmountPaid, setIsAdditionalAmountPaid] =
    useState<boolean>(false);
  const [enabledTabs, setEnabledTabs] = useState<number[]>([]);
  const [isFormValid, setIsFormValid] = useState(false);
  const { hasFunctionality, reloadFunctionalities } = useUserFunctionalities();
  const [isGovt, setIsGovt] = useState<boolean>(false);
  useEffect(() => {
    // Optionally reload functionalities when component mounts
    reloadFunctionalities();
  }, [reloadFunctionalities]);
  const [totalClaimedAmount, setTotalClaimedAmount] = useState<any>(0);
  const items = Form.useWatch("items", form);

  const patientStore = useSelector((state: RootState) => state.patients);
  const { stepperData, currentStep, stageAllState, portalData } = useSelector(
    (state: RootState) => state.preAuth
  );

  const currentStageDetails = stepperData?.currentVisitStage;
  const currentActiveStage = stepperData?.visitStages[currentStep];

  useEffect(() => {
    if (
      patientStore?.fetchBasicDetails?.casesResponse?.schemeMetaDataName?.toUpperCase() ===
        "CGHS" ||
      patientStore?.fetchBasicDetails?.casesResponse?.schemeMetaDataName?.toUpperCase() ===
        "CAPF" ||
      patientStore?.fetchBasicDetails?.casesResponse?.schemeMetaDataName?.toUpperCase() ===
        "ECHS"
    ) {
      setIsGovt(true);
    }
  }, [patientStore?.fetchBasicDetails]);

  const customStatus =
    currentActiveStage?.step && currentStageDetails?.step
      ? currentActiveStage.step === currentStageDetails.step
        ? currentStageDetails.stateId
        : currentActiveStage.step > currentStageDetails.step
        ? 8
        : 4
      : null;

  const [answersOfClinicalFindings, setAnswersOfClinicalFindings] = useState({
    // 'bloodPressure' : 'N.M.',
    // 'cardioVascularSystem' : 'N.M.',
    // 'respiratorySystem' : 'N.M.',
    // 'abdomen' : 'N.M.',
    // 'centralNervousSystem' : 'N.M.',
    // 'covidPositive' : 'N.M.',
    // 'other' : 'N.M.',
    investigations: "N.M.",
    intensiveCare: "N.M.",
    medicalManagement: "N.M.",
    surgicalManagement: "N.M.",
    procedureDescriptionMajor: "N.M.",
    procedureDescriptionMinor: "N.M.",
    otherTreatment: "N.M.",
  });

  useEffect(() => {
    if (
      props?.editedFields?.echsClaimSubmissionResponse &&
      props?.preAuthClaimData?.echsClaimSubmissionResponse
    ) {
      setAnswersOfClinicalFindings((prev) => {
        const updatedAnswers: any = { ...prev };
        Object.keys(prev)?.forEach((key) => {
          if (props?.editedFields.echsClaimSubmissionResponse[key] === "Yes") {
            updatedAnswers[key] = "Yes";
          } else {
            updatedAnswers[key] =
              props?.editedFields.echsClaimSubmissionResponse[key];
          }
        });
        return updatedAnswers;
      });
    }
  }, [props?.editedFields, props?.preAuthClaimData]);

  const styles: Record<string, React.CSSProperties> = {
    mainContent: {
      minHeight: "64px",
      background: "rgb(243, 243, 243)",
      padding: "12px 25px", // Removed the semicolon and fixed the gap
      gap: "42px", // Added the gap as a separate property
      borderRadius: "16px 16px 0px 0px", // Fixed camelCase
      borderBottom: "1px solid rgb(166, 166, 166)",
      fontWeight: "600",
      fontSize: "16px",
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
    },
    statusDesign: {
      display: "flex",
      justifyContent: "flex-end",
      alignItems: "center",
      gap: "20px",
      minWidth: "676px",
      maxHeight: "36px",
    },
    editAndSaveButtonDesign: {
      float: "right",
      position: "sticky",
      top: 0,
      backgroundColor: "white",
      zIndex: 1000,
      display: "flex",
      justifyContent: "end",
      alignItems: "center",
      padding: "10px 0",
    },
    continueButton: {
      background: "#008B8B",
      border: "1px solid #008B8B",
      boxShadow: "0px 2px 8px 0px #00000040",
      borderRadius: "10px",
      padding: "12px 25px",
      textTransform: "uppercase",
      color: "white",
    },
    saveEditButton: {
      color: "white",
      background: "#008B8B",
      border: "1px solid #008B8B",
      boxShadow: "0px 2px 8px 0px #00000040",
      borderRadius: "10px",
      padding: "12px 16px",
    },
    editButton: {
      color: "#008B8B",
      background: "white",
      border: "1px solid #008B8B",
      boxShadow: "0px 2px 8px 0px #00000040",
      borderRadius: "10px",
      padding: "12px 16px",
    },
    previousButton: {
      background: "#008B8B",
      border: "1px solid #008B8B",
      boxShadow: "0px 2px 8px 0px #00000040",
      borderRadius: "10px",
      padding: "12px 25px",
      textTransform: "uppercase",
      color: "white",
      marginRight: "10px",
    },
    submitButton: {
      marginRight: "10px",
      background: "#008B8B",
      border: "1px solid #008B8B",
      boxShadow: "0px 2px 8px 0px #00000040",
      borderRadius: "10px",
      padding: "12px 25px",
      textTransform: "uppercase",
      color: "white",
    },
  };

  useEffect(() => {
    if (currentActiveStage?.visitStageId) {
      dispatch(
        getVisitStageStates({ visitStageId: currentActiveStage?.visitStageId })
      );
    }
  }, [currentActiveStage?.visitStageId]);

  const validateForm = async () => {
    try {
      await form.validateFields({ validateOnly: true });
      setIsFormValid(true);
    } catch (errorInfo) {
      setIsFormValid(false);
    }
  };

  useEffect(() => {
    // Set form values from editedFields
    if (props?.editedFields?.cghsClaimSubmissionResponse) {
      form.setFieldsValue(props?.editedFields?.cghsClaimSubmissionResponse);
    } else if (props?.editedFields?.ihxClaimSubmissionResponses) {
      form.setFieldsValue(props?.editedFields?.ihxClaimSubmissionResponses);
    } else if (props?.editedFields?.echsClaimSubmissionResponse) {
      const updatedFields = Object.keys(
        props?.editedFields.echsClaimSubmissionResponse
      ).reduce((acc, key) => {
        if (key.toLowerCase().includes("date")) {
          acc[key] = props?.editedFields.echsClaimSubmissionResponse[key]
            ? dayjs(
                props?.editedFields.echsClaimSubmissionResponse[key],
                "DD-MM-YYYY HH:mm:ss"
              )
            : null;
        } else if (key === "items") {
          acc[key] =
            items || props?.editedFields.echsClaimSubmissionResponse[key];
        } else {
          acc[key] = props?.editedFields.echsClaimSubmissionResponse[key]; // Retain the original value for other fields
        }
        return acc;
      }, {} as Record<string, any>);
      form.setFieldsValue(updatedFields);
    }
  }, [props?.editedFields, form]);

  useEffect(() => {
    if (!props?.isSubmitted) {
      validateForm();
    }
  }, [form, props?.editedFields]);

  // useEffect(() => {
  //   if (
  //     !form.getFieldValue("items") &&
  //     !props?.editedFields?.echsClaimSubmissionResponse?.["items"]
  //   ) {
  //     form.setFieldsValue({ items: [{}] });
  //   }
  // }, [props?.editedFields]);

  const handleSubmit = async () => {
    if (props?.preAuthClaimData) {
      try {
        await form.validateFields();

        props?.handleSaveChangesEchs();
      } catch (errorInfo) {
        message.error("Please fill all required fields before submitting.");
      }
    }
  };

  const areAllMandatoryFieldsFilled = () => {
    if (!props?.preAuthClaimData) return false;

    const currentTabTitle = props?.allWizardSteps[props?.activeStep]?.title;
    let currentTabFields: PreAuthClaimField[] = [];

    Object.values(props?.preAuthClaimData)?.forEach((sections) => {
      if (sections) {
        Object.keys(sections)?.forEach((key) => {
          const caseType = sections[key as keyof PreAuthClaimResponse] && [
            sections[key as keyof PreAuthClaimResponse],
          ];

          if (caseType) {
            caseType?.forEach((section: any) => {
              Object.entries(section)?.forEach(([sectionTitle, fields]) => {
                if (section[currentTabTitle]) {
                  currentTabFields = section[currentTabTitle];
                }
              });
            });
          }
        });
      }
    });

    return currentTabFields?.every((field) => {
      if (field?.required && field.type !== "document-show") {
        const value =
          props?.editedFields[Object.keys(props?.editedFields)[0]]?.[field?.id];
        return value !== undefined && value !== null && value !== "";
      }
      return true;
    });
  };

  const areAllMandatoryFieldsTabFilled = (stepTitle: string) => {
    if (!props?.preAuthClaimData) return false;

    let currentTabFields: PreAuthClaimField[] = [];

    Object.values(props?.preAuthClaimData)?.forEach((sections) => {
      if (sections) {
        Object.keys(sections)?.forEach((key) => {
          const caseType = sections[key as keyof PreAuthClaimResponse] && [
            sections[key as keyof PreAuthClaimResponse],
          ];

          if (caseType) {
            caseType?.forEach((section: any) => {
              Object.entries(section)?.forEach(([sectionTitle, fields]) => {
                if (section[stepTitle]) {
                  currentTabFields = section[stepTitle];
                }
              });
            });
          }
        });
      }
    });

    return currentTabFields?.every((field) => {
      if (field?.required) {
        const value =
          props?.editedFields[Object.keys(props?.editedFields)[0]]?.[field?.id];
        return value !== undefined && value !== null && value !== "";
      }
      return true;
    });
  };

  useEffect(() => {
    const newEnabledTabs = [0]; // Always enable the first tab
    for (let i = 1; i <= props?.activeStep; i++) {
      if (areAllMandatoryFieldsTabFilled(props?.allWizardSteps[i - 1]?.title)) {
        newEnabledTabs.push(i);
      } else {
        break; // Stop enabling tabs if a step with unfilled mandatory fields is found
      }
    }
    setEnabledTabs(newEnabledTabs);
  }, [
    props?.editedFields,
    props?.allWizardSteps,
    props?.preAuthClaimData,
    props?.activeStep,
  ]);

  const handleSubmitForSavetoEdge = async () => {
    if (props?.preAuthClaimData && !props?.deficiencyModal) {
      try {
        await form.validateFields();
        props?.handleSaveToEdgePro();
        // If validation passes, call onSaveChanges
      } catch (errorInfo) {
        message.error("Please fill all required fields before submitting.");
      }
    }
  };

  const handleEdit = () => {
    props?.handleEditable();
  };

  useEffect(() => {
    for (const sectionKey in props.editedFields) {
      if (props.editedFields[sectionKey]?.additionalAmountPaid === "true") {
        setIsAdditionalAmountPaid(true);
      } else {
        setIsAdditionalAmountPaid(false);
      }
    }
  }, [props?.editedFields]);

  useEffect(() => {
    form.setFieldsValue(props?.preAuthClaimData);
  }, [props?.preAuthClaimData]);

  useEffect(() => {
    const items = form.getFieldValue("items");
    if (items?.length > 0) {
      const total = items?.reduce((sum: any, procedure: any) => {
        const amount =
          parseFloat(procedure?.hospitalRate || "0") *
          parseFloat(procedure?.expenseUnit);
        return sum + (isNaN(amount) ? 0 : amount);
      }, 0);
      setTotalClaimedAmount(total);
      if (parseFloat(total) > 0) {
        dispatch(
          updateField({
            sectionKey: "echsClaimSubmissionResponse",
            fieldId: "claimedAmount",
            value: total?.toString(),
          })
        );
      }
    } else {
      setTotalClaimedAmount(0);
    }
  }, [form, items]);

  const renderTabContent = (stepTitle: string) => {
    if (!props?.preAuthClaimData) {
      return (
        <div style={{ width: "100%" }}>
          <Empty />
        </div>
      );
    }

    const responseKeys = [
      "ihxClaimSubmissionResponses",
      "cghsClaimSubmissionResponse",
      "echsClaimSubmissionResponse",
      "starHealthClaimSubmissionResponse",
      "vidalClaimSubmissionResponse",
    ];

    const caseType = ["op", "ip", "emergency"];

    for (const key of responseKeys) {
      const claimData =
        props?.preAuthClaimData[key as keyof PreAuthClaimResponse];
      if (
        claimData &&
        props?.visitType &&
        key?.toLowerCase()?.includes("echs")
      ) {
        for (const caseTypeKey of caseType) {
          const data = claimData[caseTypeKey as any];
          if (data) {
            const sectionData = data?.[stepTitle];
            if (sectionData || stepTitle.toLowerCase().includes("procedure")) {
              return (
                <Form
                  form={form}
                  onFinish={handleSubmit}
                  labelAlign="left"
                  labelWrap
                  labelCol={{
                    xs: { span: 24 },
                    sm: { span: 12 },
                    md: { span: 8 },
                    lg: { span: 6 },
                  }}
                  wrapperCol={{
                    xs: { span: 24 },
                    sm: { span: 12 },
                    md: { span: 16 },
                    lg: { span: 18 },
                  }}
                  style={{ width: "100%", marginLeft: "20px" }}
                >
                  {stepTitle.toLowerCase().includes("procedure")
                    ? renderMultipleItems()
                    : sectionData?.map(
                        (field: PreAuthClaimField, index: number) => (
                          <Row key={field.id}>
                            {renderCommonField({
                              field,
                              index,
                              isReadOnly:
                                !props?.isEditable &&
                                props?.caseClaimSubmissionId
                                  ? true
                                  : !field.updatable,
                              onFieldChange: (_, fieldId, value) =>
                                props?.onFieldChange(key, fieldId, value),
                              handleFileChange: props?.handleFileChange,
                              value:
                                props?.editedFields[key]?.[field.id] ??
                                field.data ??
                                "",
                              key: key,
                              form: form,
                              isAdditionalAmountPaid: isAdditionalAmountPaid,
                              caseSubmissionId: props?.caseClaimSubmissionId,
                              handleSetDocumentUrl: props?.handleSetDocumentUrl,
                              handleOpen: props?.handleOpen,
                              handleDownloadDocument:
                                props?.handleDownloadDocument,
                              isDownloadingDocument:
                                props?.isDownloadingDocument,
                              downloadingDocumentUrl:
                                props?.downloadingDocumentUrl,
                              handleDeleteList: props?.handleDeleteList,
                              uploadedDocumentUrl: props?.uploadedDocumentUrl,
                              handleDeficiencyModal:
                                props?.handleDeficiencyModal,
                              closeDeficiencyModal: props?.closeDeficiencyModal,
                              deficiencyModal: props?.deficiencyModal,
                              deficiencyQuestions: props?.deficiencyQuestions,
                              previewDocumentUrl: props?.previewDocumentUrl,
                              setDocumentName: props?.setDocumentName,
                              handleDeficiencyModalAfterSave:
                                props?.handleDeficiencyModalAfterSave,
                              totalClaimedAmount: totalClaimedAmount,
                              answersOfClinicalFindings:
                                answersOfClinicalFindings,
                            })}
                          </Row>
                        )
                      )}
                </Form>
              );
            }
          }
        }
      }
    }

    return (
      <div style={{ width: "100%" }}>
        <Empty />
      </div>
    );
  };

  const renderMultipleItems = () => {
    return (
      <Form.List name="items">
        {(fields, { add, remove }) => (
          <>
            {Array.isArray(fields) &&
              fields?.map((field, index) => {
                return (
                  <Row
                    key={field.key}
                    gutter={[16, 16]}
                    align="top"
                    style={{
                      border: "1px solid black",
                      padding: "10px 20px",
                      borderRadius: "16px",
                      marginBottom: "0.8rem",
                    }}
                  >
                    <Col span={8}>
                      <Form.Item
                        {...field}
                        label="Procedure"
                        name={[field.name, "procedureID"]}
                        rules={[{ required: true, message: "Required" }]}
                        labelCol={{ span: 24 }}
                        wrapperCol={{ span: 24 }}
                        style={{ display: "flex", flexDirection: "column" }}
                      >
                        <Select
                          showSearch
                          defaultValue={`Select a Procedure`}
                          // options={procedureMapping?.map((option: any) => ({
                          //   value: option?.rateType + "~" + option?.expenseType + "~" + option?.expenseCode + "~" + option?.procedureID + "~" + option?.expenseName + "~" + option?.normalRate + "~" + option?.expenseUnit + "~" + option?.admissibleRate,
                          //   // value: JSON.stringify(option),
                          //   label: option?.expenseName,
                          // }))}
                          options={
                            props?.procedureDropDown?.length > 0 &&
                            props?.procedureDropDown?.map((option: any) => {
                              const {
                                hospitalAmount,
                                hospitalRate,
                                hospitalRemark,
                                expenseUnit,
                                ...rest
                              } = option;
                              return {
                                value: JSON.stringify(rest),
                                label: rest.expenseName,
                                expenseUnit,
                              };
                            })
                          }
                          onChange={(value, option) => {
                            const values = value.split("~");
                            const expenseCode = JSON.parse(value).expenseCode; //values[2]; // Extracting expenseCode
                            // const expenseUnit = JSON.parse(value).expenseUnit //values[6]; // Extracting expenseUnit
                            const admissibleRate =
                              JSON.parse(value).admissibleRate; //values[7];
                            const expenseUnit = (option as any).expenseUnit;

                            form.setFieldsValue({
                              items: {
                                [index]: {
                                  expenseCode,
                                  expenseUnit,
                                  admissibleRate,
                                },
                              },
                            });
                            dispatch(
                              updateField({
                                sectionKey: "echsClaimSubmissionResponse",
                                fieldId: "items",
                                value: form.getFieldsValue(["items"])?.items,
                              })
                            );
                          }}
                          disabled={
                            !props?.isEditable && props?.caseClaimSubmissionId
                              ? true
                              : false
                          }
                        />
                      </Form.Item>
                    </Col>

                    <Col span={8}>
                      <Form.Item
                        {...field}
                        label="Procedure Code"
                        name={[field.name, "expenseCode"]}
                        rules={[{ required: true, message: "Required" }]}
                        labelCol={{ span: 24 }}
                        wrapperCol={{ span: 24 }}
                        style={{ display: "flex", flexDirection: "column" }}
                      >
                        <Input
                          style={{ borderRadius: "5px" }}
                          placeholder="Enter Procedure Code"
                          onChange={(e) => {
                            const enteredExpenseCode = e.target.value.trim();
                            const matchedProcedure =
                              props?.procedureDropDown?.find(
                                (item: any) =>
                                  item.expenseCode === enteredExpenseCode
                              );

                            if (matchedProcedure) {
                              // const procedureValue = `${matchedProcedure.rateType}~${matchedProcedure.expenseType}~${matchedProcedure.expenseCode}~${matchedProcedure.procedureID}~${matchedProcedure.expenseName}~${matchedProcedure.normalRate}~${matchedProcedure.expenseUnit}~${matchedProcedure.admissibleRate}`;
                              const procedureValue = JSON.stringify({
                                rateType: matchedProcedure.rateType,
                                expenseType: matchedProcedure.expenseType,
                                expenseCode: matchedProcedure.expenseCode,
                                procedureID: matchedProcedure.procedureID,
                                expenseName: matchedProcedure.expenseName,
                                normalRate: matchedProcedure.normalRate,
                                admissibleRate: matchedProcedure.admissibleRate,
                              });

                              form.setFieldsValue({
                                items: {
                                  [index]: {
                                    procedureID: procedureValue,
                                    expenseUnit: matchedProcedure?.expenseUnit,
                                    admissibleRate:
                                      matchedProcedure?.admissibleRate,
                                  },
                                },
                              });
                              dispatch(
                                updateField({
                                  sectionKey: "echsClaimSubmissionResponse",
                                  fieldId: "items",
                                  value: form.getFieldsValue(["items"])?.items,
                                })
                              );
                            } else {
                              form.setFieldsValue({
                                items: {
                                  [index]: {
                                    procedureID: null,
                                    admissibleRate: null,
                                  },
                                },
                              });
                              dispatch(
                                updateField({
                                  sectionKey: "echsClaimSubmissionResponse",
                                  fieldId: "items",
                                  value: form.getFieldsValue(["items"])?.items,
                                })
                              );
                            }
                          }}
                          disabled={
                            !props?.isEditable && props?.caseClaimSubmissionId
                              ? true
                              : false
                          }
                        />
                      </Form.Item>
                    </Col>

                    <Col span={7}>
                      <Form.Item
                        {...field}
                        label="QUANTITY/NO OF DAYS"
                        name={[field.name, "expenseUnit"]}
                        rules={[{ required: true, message: "Required" }]}
                        labelCol={{ span: 24 }}
                        wrapperCol={{ span: 24 }}
                        style={{ display: "flex", flexDirection: "column" }}
                      >
                        <Input
                          style={{ borderRadius: "5px" }}
                          placeholder="Enter QUANTITY/NO OF DAYS"
                          onChange={(e) => {
                            const enteredExpenseUnit = e.target.value.trim();
                            const hospitalRate = form.getFieldValue([
                              "items",
                              index,
                              "hospitalRate",
                            ]);

                            if (hospitalRate && enteredExpenseUnit) {
                              const hospitalAmount =
                                parseFloat(hospitalRate) *
                                parseFloat(enteredExpenseUnit);
                              form.setFieldsValue({
                                items: {
                                  [index]: {
                                    hospitalAmount: hospitalAmount?.toString(),
                                  },
                                },
                              });
                              dispatch(
                                updateField({
                                  sectionKey: "echsClaimSubmissionResponse",
                                  fieldId: "items",
                                  value: form.getFieldsValue(["items"])?.items,
                                })
                              );
                            } else {
                              form.setFieldsValue({
                                items: {
                                  [index]: {
                                    hospitalAmount: 0,
                                  },
                                },
                              });
                              dispatch(
                                updateField({
                                  sectionKey: "echsClaimSubmissionResponse",
                                  fieldId: "items",
                                  value: form.getFieldsValue(["items"])?.items,
                                })
                              );
                            }
                          }}
                          disabled={
                            !props?.isEditable && props?.caseClaimSubmissionId
                              ? true
                              : false
                          }
                        />
                      </Form.Item>
                    </Col>

                    <Col span={1}>
                      {fields.length > 0 &&
                        !(!props?.isEditable && props?.caseClaimSubmissionId) &&
                        (props?.portalSubmission === "save as draft" ||
                          props?.portalSubmission === null) && (
                          <Button
                            type="text"
                            style={{ color: "red", padding: "0" }}
                            icon={<MinusCircleOutlined />}
                            onClick={() => {
                              const procedure = form.getFieldValue([
                                "items",
                                index,
                              ]);
                              if (procedure?.id) {
                                const res =
                                  props?.handleDeleteProcedure(procedure);
                                if (res) {
                                  remove(field.name);
                                }
                              } else {
                                remove(field.name);
                              }
                            }}
                          />
                        )}
                    </Col>

                    <Col span={8}>
                      <Form.Item
                        {...field}
                        label="ECHS RATE"
                        name={[field.name, "admissibleRate"]}
                        rules={[{ required: true, message: "Required" }]}
                        labelCol={{ span: 24 }}
                        wrapperCol={{ span: 24 }}
                        style={{ display: "flex", flexDirection: "column" }}
                      >
                        <Input
                          style={{ borderRadius: "5px" }}
                          placeholder="Enter ECHS RATE"
                          disabled={true}
                        />
                      </Form.Item>
                    </Col>

                    <Col span={8}>
                      <Form.Item
                        {...field}
                        label="Hospital Rate"
                        name={[field.name, "hospitalRate"]}
                        rules={[
                          { required: true, message: "Required" },
                          {
                            pattern: /^\d+$/,
                            message: "Numeric values are allow!",
                          },
                          {
                            validator: async (_, value) => {
                              const admissibleRate = form.getFieldValue([
                                "items",
                                index,
                                "admissibleRate",
                              ]);
                              if (
                                value &&
                                parseFloat(value) > parseFloat(admissibleRate)
                              ) {
                                return Promise.reject(
                                  new Error(
                                    `Hospital Rate must be lesser than or equal to ${admissibleRate}`
                                  )
                                );
                              }
                            },
                          },
                        ]}
                        labelCol={{ span: 24 }}
                        wrapperCol={{ span: 24 }}
                        style={{ display: "flex", flexDirection: "column" }}
                      >
                        <Input
                          style={{ borderRadius: "5px" }}
                          placeholder="Enter Hospital Rate"
                          onChange={(e) => {
                            const enteredHospitalRate = e.target.value.trim();
                            const admissibleRate = form.getFieldValue([
                              "items",
                              index,
                              "admissibleRate",
                            ]);
                            const expenseUnit = form.getFieldValue([
                              "items",
                              index,
                              "expenseUnit",
                            ]);

                            if (
                              parseFloat(enteredHospitalRate) >
                              parseFloat(admissibleRate)
                            ) {
                              errorMessage(
                                `Hospital Rate must be lesser than or equal to ${admissibleRate}`
                              );
                            } else if (expenseUnit && enteredHospitalRate) {
                              const hospitalAmount =
                                parseFloat(expenseUnit) *
                                parseFloat(enteredHospitalRate);
                              form.setFieldsValue({
                                items: {
                                  [index]: {
                                    hospitalAmount: hospitalAmount?.toString(),
                                  },
                                },
                              });
                              dispatch(
                                updateField({
                                  sectionKey: "echsClaimSubmissionResponse",
                                  fieldId: "items",
                                  value: form.getFieldsValue(["items"])?.items,
                                })
                              );
                            } else {
                              form.setFieldsValue({
                                items: {
                                  [index]: {
                                    hospitalAmount: 0,
                                  },
                                },
                              });
                              dispatch(
                                updateField({
                                  sectionKey: "echsClaimSubmissionResponse",
                                  fieldId: "items",
                                  value: form.getFieldsValue(["items"])?.items,
                                })
                              );
                            }
                          }}
                          disabled={
                            !props?.isEditable && props?.caseClaimSubmissionId
                              ? true
                              : false
                          }
                        />
                      </Form.Item>
                    </Col>

                    <Col span={7}>
                      <Form.Item
                        {...field}
                        label="Remarks"
                        name={[field.name, "hospitalRemark"]}
                        // rules={[{ required: true, message: "Required" }]}
                        labelCol={{ span: 24 }}
                        wrapperCol={{ span: 24 }}
                        style={{ display: "flex", flexDirection: "column" }}
                      >
                        <Input
                          style={{ borderRadius: "5px" }}
                          placeholder="Enter Remarks"
                          onChange={() =>
                            form.getFieldsValue(["items"])
                              ? dispatch(
                                  updateField({
                                    sectionKey: "echsClaimSubmissionResponse",
                                    fieldId: "items",
                                    value: form.getFieldsValue(["items"])
                                      ?.items,
                                  })
                                )
                              : null
                          }
                          disabled={
                            !props?.isEditable && props?.caseClaimSubmissionId
                              ? true
                              : false
                          }
                        />
                      </Form.Item>
                    </Col>

                    <div style={{ width: "100%" }}>
                      <h4 style={{ display: "flex", justifyContent: "end" }}>
                        Hospital Amount: ₹{" "}
                        {form.getFieldValue([
                          "items",
                          index,
                          "hospitalAmount",
                        ]) ?? 0}
                        /-
                      </h4>
                    </div>
                  </Row>
                );
              })}
            {(props?.portalSubmission === "save as draft" ||
              props?.portalSubmission === null) && (
              <Button
                type="dashed"
                onClick={() => add()}
                style={{
                  color: "white",
                  background: "#008B8B",
                  border: "1px solid #C4C4C4",
                  boxShadow: "0px 2px 8px 0px #00000040",
                }}
                disabled={
                  !props?.isEditable && props?.caseClaimSubmissionId
                    ? true
                    : false
                }
              >
                Add Procedure
              </Button>
            )}
            <div style={{ width: "100%", marginBottom: "0.8rem" }}>
              <h4 style={{ display: "flex", justifyContent: "end" }}>
                Total Amount: ₹ {totalClaimedAmount}/-
              </h4>
            </div>
          </>
        )}
      </Form.List>
    );
  };

  // if (props.isLoading) {
  //   return <div>Loading...</div>;
  // }

  if (props.error) {
    return <div>Error: {props.error}</div>;
  }

  return (
    <>
      <div
        style={{
          border: "0.4px solid rgb(87, 87, 87)",
          gap: "15px",
          borderRadius: "16px",
          margin: "0px 0.5rem",
        }}
      >
        <div
          style={{
            minHeight: "64px",
            background: "rgb(243, 243, 243)",
            padding: "12px 35px", // Removed the semicolon and fixed the gap
            gap: "42px", // Added the gap as a separate property
            borderRadius: "16px 16px 0px 0px", // Fixed camelCase
            borderBottom: "1px solid rgb(166, 166, 166)",
            fontWeight: "600",
            fontSize: "16px",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <span style={{ fontSize: "20px", alignContent: "center" }}>
            CLAIM SUBMISSION
          </span>
          <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
              alignItems: "center",
              gap: "20px",
              minWidth: "676px",
              maxHeight: "36px",
            }}
          >
            <ClaimIDManuallyId />
            {currentActiveStage?.visitStageId &&
              patientStore?.fetchBasicDetails?.visitInfoResponse?.id && (
                <ManualStatus
                  stateData={
                    stageAllState?.[currentActiveStage?.visitStageId] || null
                  }
                  status={customStatus}
                  visitId={
                    patientStore?.fetchBasicDetails?.visitInfoResponse?.id
                  }
                  visitStageId={currentActiveStage?.visitStageId}
                  // isUpdateable={
                  //   customStatus == 4
                  //     ? false
                  //     : true
                  // }
                  isUpdateable={true}
                />
              )}
            {(patientStore?.fetchBasicDetails?.visitInfoResponse
              ?.portalStatus ||
              true) && (
              <ManualPortalStatus
                status={
                  patientStore?.fetchBasicDetails?.visitInfoResponse
                    ?.portalStatus || "-"
                }
                visitId={patientStore?.fetchBasicDetails?.visitInfoResponse?.id}
                visitStageId={currentActiveStage?.visitStageId}
                isUpdateable={
                  hasFunctionality("portalStatus") && !isGovt ? true : false
                }
              />
            )}
          </div>
        </div>
        <div style={{ padding: "20px 45px 20px 25px" }}>
          <div
            style={{
              float: "right",
              position: "sticky",
              top: 0,
              backgroundColor: "white",
              zIndex: 1000,
              display: "flex",
              justifyContent: "end",
              alignItems: "center",
              padding: "10px 0",
            }}
          >
            <Space>
              {props?.preAuthClaimData?.echsClaimSubmissionResponse &&
              props?.caseClaimSubmissionId &&
              (props?.portalSubmission === "save as draft" ||
                props?.portalSubmission === null) ? (
                props?.isEditable ? (
                  <></>
                ) : (
                  // <Button
                  //   type="primary"
                  //   icon={<SaveOutlined />}
                  //   onClick={() => {
                  //     handleSubmit();
                  //     handleSubmitForSavetoEdge();
                  //   }}

                  //   // disabled={!isFormValid}
                  // >
                  //   Save
                  // </Button>
                  <Button
                    style={{
                      color: "#008B8B",
                      background: "white",
                      border: "1px solid #008B8B",
                      boxShadow: "0px 2px 8px 0px #00000040",
                      borderRadius: "10px",
                      padding: "12px 16px",
                    }}
                    icon={<EditOutlined />}
                    onClick={handleEdit}
                  >
                    Edit
                  </Button>
                )
              ) : (
                <></>
              )}
            </Space>
          </div>
          <Tabs
            activeKey={props?.activeStep.toString()}
            type="card"
            size="large"
            style={{ width: "100%" }}
            onChange={props?.handleTabsChange}
            items={props?.allWizardSteps?.map((step) => ({
              label: step?.title,
              key: step?.step?.toString(),
              children: renderTabContent(step?.title),
              disabled: !enabledTabs.includes(step?.step),
            }))}
          />
          {/* <Tabs
        activeKey={props.activeStep.toString()}
        type="card"
        size="large"
        // tabBarStyle={{ width: "100%" }}
        style={{ width: "100%" }}
        onChange={props.handleTabsChange}
      >
        {props.allWizardSteps?.map((step) => (
          <TabPane tab={step.title} key={step.step.toString()}>
            {renderTabContent(step.title)}
          </TabPane>
        ))}
      </Tabs> */}

          <div
            style={{
              display: "flex",
              justifyContent: "end",
              alignItems: "center",
              gap: "15px",
            }}
          >
            <>
              {props.activeStep !== 0 && (
                <Button
                  onClick={props.onPrevious}
                  style={{
                    color: "#008B8B",
                    background: "white",
                    border: "1px solid #008B8B",
                    boxShadow: "0px 2px 8px 0px #00000040",
                    borderRadius: "10px",
                    padding: "12px 25px",
                  }}
                  // style={{ marginRight: 8 }}
                >
                  Previous
                </Button>
              )}
              {props?.activeStep === props?.allWizardSteps?.length - 1 && (
                <>
                  {/* Render Save Button only if caseDischargeId is not present */}
                  {/* {(!props?.caseClaimSubmissionId || props?.isEditable) &&
                    hasFunctionality("claimCreation") && (
                      <Button
                        type="primary"
                        onClick={handleSubmitForSavetoEdge}
                        loading={props?.isLoading}
                        style={{
                       
                          color: "white",
                          background: "#008B8B",
                          border: "1px solid #008B8B",
                          boxShadow: "0px 2px 8px 0px #00000040",
                          borderRadius: "10px",
                          padding: "12px 25px",
                          
                        }}
                        // style={{ marginRight: "8px" }}
                      >
                        {!props?.caseClaimSubmissionId
                          ? "SAVE AS DRAFT"
                          : "UPDATE AS DRAFT"}
                      </Button>
                    )} */}

                  {(props.portalSubmission === "save as draft" ||
                    props.portalSubmission === null) && (
                    <>
                      {hasFunctionality("claimCreation") && (
                        <Button
                          type="primary"
                          onClick={handleSubmitForSavetoEdge}
                          loading={props?.isLoading}
                          style={styles.submitButton}
                        >
                          {!props?.caseClaimSubmissionId
                            ? "SAVE AS DRAFT"
                            : "UPDATE AS DRAFT"}
                        </Button>
                      )}
                    </>
                  )}

                  {/* Render Submit Button without caseDischargeId check */}

                  <Form.Item style={{ marginBottom: "0px" }}>
                    {hasFunctionality("claimApprover") &&
                      (props.portalSubmission === "save as draft" ||
                        props.portalSubmission === null) && (
                        <Button
                          style={{
                            background: "#008B8B",
                            marginRight: "8px",
                            float: "right",
                          }}
                          disabled={props?.isApproved}
                          type="primary"
                          icon={<CheckOutlined />}
                          onClick={props?.handleApprove}
                          loading={props?.isApprovedInitiated}
                        >
                          Approve Claim
                        </Button>
                      )}
                  </Form.Item>

                  {hasFunctionality("claimSubmission") &&
                    (props?.portalSubmission === "save as draft" ||
                      props?.portalSubmission === null) && (
                      <Button
                        type="primary"
                        style={{
                          color: "white",
                          background: "#008B8B",
                          border: "1px solid #008B8B",
                          boxShadow: "0px 2px 8px 0px #00000040",
                          borderRadius: "10px",
                          padding: "12px 25px",
                        }}
                        icon={<SaveOutlined />}
                        onClick={handleSubmit}
                        loading={props?.isLoading}
                      >
                        Submit on Portal
                      </Button>
                    )}
                  {!(
                    props?.portalSubmission === "save as draft" ||
                    props?.portalSubmission === null
                  ) && (
                    <Button
                      style={{
                        marginRight: "10px",
                        background: "#008B8B",
                        border: "1px solid #008B8B",
                        boxShadow: "0px 2px 8px 0px #00000040",
                        borderRadius: "10px",
                        padding: "12px 25px",
                        textTransform: "uppercase",
                        color: "white",
                      }}
                      onClick={() => {
                        props?.setMoveToNext(true);
                      }}
                    >
                      NEXT: {props?.nextStage?.visitStage}
                    </Button>
                  )}
                </>
              )}
            </>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "flex-end",
                gap: "15px",
              }}
            >
              {props.activeStep !== props.allWizardSteps.length - 1 && (
                <Button
                  style={{
                    color: "white",
                    background: "#008B8B",
                    border: "1px solid #008B8B",
                    boxShadow: "0px 2px 8px 0px #00000040",
                    borderRadius: "10px",
                    padding: "12px 25px",
                  }}
                  onClick={() => {
                    if (props.activeStep === props.allWizardSteps.length - 1) {
                      props.onComplete(props.activeStep);
                    } else {
                      props.onNext();
                    }
                  }}
                  disabled={
                    !props.allWizardSteps[props.activeStep]?.canNavigate ||
                    !areAllMandatoryFieldsFilled()
                  }
                >
                  {props.activeStep === props.allWizardSteps.length - 1
                    ? "Submit"
                    : "Save And Continue"}
                </Button>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default PreAuthClaimEchs;
